import React from 'react';
import loadable from '@loadable/component';
import { Container } from '@hpi-sox/hpstellar-core';
import { Helpers } from '../../core';

import './category-landing-page.less';

const Questionnaire = loadable(() => Helpers.retryFunc(() => import('../../vwa/questionnaire')));

export default ({ vanityUrl }) => {
    if (vanityUrl !== 'cat/printers') {
        return null;
    }
    return (
        <Container className='questionnaire-container'>
            <Questionnaire />
        </Container>
    );
};
